// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"FormModal_loadingIndicator__SQGw1","formBody":"FormModal_formBody__2jRQ_","modal":"FormModal_modal__2rQw9"};